module.exports = __webpack_public_path__ + "img/security.ade16433.gif";